import { Injectable } from '@angular/core';
import { Resource, Service } from 'ngx-jsonapi';
import { lastValueFrom } from 'rxjs';

export interface StyleOption {
  id: number;
  name: string;
}

export class Style extends Resource {
  public override attributes = {
    name: '',
    slug: '',
  };

  public override relationships = {};
}

@Injectable({
  providedIn: 'root',
})
export class StyleService extends Service<Style> {
  public override resource = Style;
  public override type = 'Style';
  public override path = '/api/styles';

  public async fetchArtistStyleOptions(): Promise<StyleOption[]> {
    const page = await lastValueFrom(this.all({
      page: {
        number: 1,
        size: 200,
      },
    }));

    return page.data.map((style) => ({
      id: Number(style.id),
      name: style.attributes.name,
    }));
  }
}
